import {
  MutationCache,
  QueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { toaster } from './toaster';

export type MutationConfig<
  MutationFnType extends (...args: any[]) => Promise<unknown>,
> = UseMutationOptions<
  Awaited<ReturnType<MutationFnType>>,
  Error,
  Parameters<MutationFnType>[0]
>;
// Create a QueryClient instance
export const queryClient: QueryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (data) => {
      toaster.error(data.message || 'An unexpected error occurred', {
        description: isAxiosError(data)
          ? (data.response?.data as string)
          : data.message,
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 60 * 5 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});
